module.exports = __webpack_public_path__ + "static/media/canada9.fad509bd.jpg";